export default {
  title: {
    id: 'us_telco_comparators_landing_page_savings_title',
    defaultMessage: 'A pre-paid plan could save you thousands over 3 years',
  },
  subtitle: {
    id: 'us_telco_comparators_landing_page_savings_subtitle',
    defaultMessage: 'Find out how much you could save versus a contract plan.',
  },
  baselineTitle: {
    id: 'us_telco_comparators_landing_page_savings_baseline_title',
    defaultMessage: 'Typical contract plan',
  },
  baselinePhoneCostLabel: {
    id: 'us_telco_comparators_landing_page_savings_baseline_phone_cost_label',
    defaultMessage: 'Cost of an iPhone 15 Pro',
  },
  baselinePhoneCostValue: {
    id: 'us_telco_comparators_landing_page_savings_baseline_phone_cost_value',
    defaultMessage: '$0',
  },
  baselinePlanCostLabel: {
    id: 'us_telco_comparators_landing_page_savings_baseline_plan_cost_label',
    defaultMessage: 'Cost of monthly plan',
  },
  baselinePlanCostValue: {
    id: 'us_telco_comparators_landing_page_savings_baseline_plan_cost_value',
    defaultMessage: '$90/mo',
  },
  baselineTotalCostLabel: {
    id: 'us_telco_comparators_landing_page_savings_baseline_total_cost_label',
    defaultMessage: 'Total cost for 3 years',
  },
  baselineTotalCostValue: {
    id: 'us_telco_comparators_landing_page_savings_baseline_total_cost_value',
    defaultMessage: '$3,240',
  },
  vsLabel: {
    id: 'us_telco_comparators_landing_page_savings_vs_label',
    defaultMessage: 'vs',
  },
  comparisonTitle: {
    id: 'us_telco_comparators_landing_page_savings_comparison_title',
    defaultMessage: 'Example savings with an iPhone 15 Pro from Back Market',
  },
  colPhoneCost: {
    id: 'us_telco_comparators_landing_page_savings_col_phone_cost',
    defaultMessage: 'Cost of iPhone 15 Pro',
  },
  colPlanCost: {
    id: 'us_telco_comparators_landing_page_savings_col_plan_cost',
    defaultMessage: 'Cost of plan',
  },
  colTotalCost: {
    id: 'us_telco_comparators_landing_page_savings_col_total_cost',
    defaultMessage: 'Total cost for 3 years',
  },
  visibleName: {
    id: 'us_telco_comparators_landing_page_savings_visible_name',
    defaultMessage: 'Visible by Verizon',
  },
  visiblePhoneCost: {
    id: 'us_telco_comparators_landing_page_savings_visible_phone_cost',
    defaultMessage: '$550',
  },
  visiblePlanCost: {
    id: 'us_telco_comparators_landing_page_savings_visible_plan_cost',
    defaultMessage: '$15/mo',
  },
  visibleTotalCost: {
    id: 'us_telco_comparators_landing_page_savings_visible_total_cost',
    defaultMessage: '$1,090',
  },
  visibleSavingsAmount: {
    id: 'us_telco_comparators_landing_page_savings_visible_savings_amount',
    defaultMessage: '$2,150',
  },
  usMobileName: {
    id: 'us_telco_comparators_landing_page_savings_us_mobile_name',
    defaultMessage: 'US Mobile',
  },
  usMobilePhoneCost: {
    id: 'us_telco_comparators_landing_page_savings_us_mobile_phone_cost',
    defaultMessage: '$450',
  },
  usMobilePhoneCostStrikethrough: {
    id: 'us_telco_comparators_landing_page_savings_us_mobile_phone_cost_strikethrough',
    defaultMessage: '$500',
  },
  usMobilePhoneDiscount: {
    id: 'us_telco_comparators_landing_page_savings_us_mobile_phone_discount',
    defaultMessage: 'with $100 off your phone',
  },
  usMobilePlanCost: {
    id: 'us_telco_comparators_landing_page_savings_us_mobile_plan_cost',
    defaultMessage: '$17/mo',
  },
  usMobileTotalCost: {
    id: 'us_telco_comparators_landing_page_savings_us_mobile_total_cost',
    defaultMessage: '$1,062',
  },
  usMobileSavingsAmount: {
    id: 'us_telco_comparators_landing_page_savings_us_mobile_savings_amount',
    defaultMessage: '$2,178',
  },
  nobleName: {
    id: 'us_telco_comparators_landing_page_savings_noble_name',
    defaultMessage: 'Noble Mobile',
  },
  noblePhoneCost: {
    id: 'us_telco_comparators_landing_page_savings_noble_phone_cost',
    defaultMessage: '$400',
  },
  noblePhoneCostStrikethrough: {
    id: 'us_telco_comparators_landing_page_savings_noble_phone_cost_strikethrough',
    defaultMessage: '$500',
  },
  noblePhoneDiscount: {
    id: 'us_telco_comparators_landing_page_savings_noble_phone_discount',
    defaultMessage: 'with $150 off your phone',
  },
  noblePlanCost: {
    id: 'us_telco_comparators_landing_page_savings_noble_plan_cost',
    defaultMessage: '$50/mo',
  },
  nobleTotalCost: {
    id: 'us_telco_comparators_landing_page_savings_noble_total_cost',
    defaultMessage: '$2,200',
  },
  nobleSavingsAmount: {
    id: 'us_telco_comparators_landing_page_savings_noble_savings_amount',
    defaultMessage: '$1,040',
  },
  disclaimer: {
    id: 'us_telco_comparators_landing_page_savings_disclaimer',
    defaultMessage:
      'Savings estimates are based on a 36-month total cost of ownership (TCO) comparison between Back Market partner plans and comparable postpaid plans from Verizon, AT&T, and T-Mobile, calculated as of July 2026. Back Market TCO includes the purchase price of a refurbished smartphone on BackMarket.com and the monthly cost of the applicable partner plan over 36 months, including any promotional plan discounts and device credits. Carrier TCO includes the net device cost after trade-in credit applied as monthly bill credits (Verizon: up to $1,100 off iPhone 17 Pro Max on Unlimited Ultimate; AT&T: up to $1,100 off iPhone 17 Pro on an eligible unlimited plan; T-Mobile: up to $1,100 off iPhone 17 Pro on Experience Beyond), plus 36 months of plan costs at the applicable monthly rate. Carrier pricing and promotional offers are subject to change; savings may vary based on selected plan tier, device model, trade-in eligibility, and individual usage. Forfeiture of carrier bill credits due to early plan cancellation is not reflected in carrier TCO. Back Market partner plan pricing reflects rates available exclusively through BackMarket.com at time of publication.',
  },
  versus: {
    id: 'us_telco_comparators_landing_page_savings_versus',
    defaultMessage: 'vs',
  },
  mobileBaselineName: {
    id: 'us_telco_comparators_landing_page_savings_mobile_baseline_name',
    defaultMessage: 'Typical Verizon contract',
  },
  mobileBaselinePhoneCost: {
    id: 'us_telco_comparators_landing_page_savings_mobile_baseline_phone_cost',
    defaultMessage: '$0',
  },
  mobileBaselinePlanCost: {
    id: 'us_telco_comparators_landing_page_savings_mobile_baseline_plan_cost',
    defaultMessage: '$90/mo',
  },
  mobileBaselineTotalCost: {
    id: 'us_telco_comparators_landing_page_savings_mobile_baseline_total_cost',
    defaultMessage: '$3,240',
  },
}
